import React from "react";

class AutoFocusTextInput extends React.Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef();
    }

    componentDidMount() {
        setTimeout(() => {
            this.textInput.current.focus();
            this.textInput.current.select();
        }, 500);
    }
    
    render() {
        return <input ref={this.textInput} {...this.props} />;
    }
}

export default AutoFocusTextInput;